import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-operator-bridge-section',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
  templateUrl: './operator-bridge-section.component.html',
  styleUrl: './operator-bridge-section.component.scss'
})
export class OperatorBridgeSectionComponent {
  operatorSignals = [
    { icon: 'domain', label: 'Standardize workflows across multiple organizations' },
    { icon: 'payments', label: 'Centralize dues, payments, renewals, and event revenue' },
    { icon: 'monitoring', label: 'Give every board clean reporting without rebuilding spreadsheets' }
  ];
}
